import { render, staticRenderFns } from "./SoloSentiment.vue?vue&type=template&id=e3d0194a&"
import script from "./SoloSentiment.vue?vue&type=script&lang=ts&"
export * from "./SoloSentiment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports